module.exports = __webpack_public_path__ + "img/2022-19.2727a2ff.jpg";